import { useTranslations } from '@lang';
import moment from 'moment';
import { Item } from 'shared-types';
import { formatExtraLabel } from '@common/helpers/formatExtraLabel';
import { pluralizeAdults, pluralizeChildren } from '../BasketDrawer.helpers';
import { BasketDrawerTextWrapper, BasketItemText, Listing } from '../BasketDrawer.styles';

export const RoomListing = ({ rooms }: { rooms: Item[] }) => {
  const { t } = useTranslations();
  return (
    <Listing>
      {rooms.map((room) => {
        const roomExtras = room?.bookable?.roomExtras ?? [];
        return (
          <div data-testid="room-listing" key={room.id}>
            <BasketDrawerTextWrapper>
              {moment(room?.checkIn).format('ddd, D MMM')} -{' '}
              {moment(room?.checkOut).format('ddd, D MMM')}
            </BasketDrawerTextWrapper>
            <BasketDrawerTextWrapper marginBottom="10px">
              <BasketItemText>{room?.bookable?.name}</BasketItemText>
              <BasketItemText>
                {room.adults} {pluralizeAdults(room?.adults ?? 1, t)}
              </BasketItemText>
              {!!(room.children && room.children > 0) && (
                <BasketItemText>
                  {room?.children} {pluralizeChildren(room.children, t)}
                </BasketItemText>
              )}
            </BasketDrawerTextWrapper>
            {roomExtras.length > 0 &&
              roomExtras.map((extra, index) => {
                const label = formatExtraLabel(extra.name, extra.quantity, 'x');
                if (!label) return null;
                return (
                  <BasketDrawerTextWrapper key={`${extra.name}-${index}`} marginBottom="10px">
                    <BasketItemText>{label}</BasketItemText>
                  </BasketDrawerTextWrapper>
                );
              })}
          </div>
        );
      })}
    </Listing>
  );
};
